import { Url, CHECKOUT_IDS } from '@wix/da-url';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger/constants';

interface Item {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  biData?: any;
}
export const getItems = (
  t,
  {
    pushBadgeModal,
    pushPointsModal,
    onLlamaBadgeSent,
    onCakeBadgeSent,
    profileOwnerUser,
    profileOwnerUser: { username, userId },
    giveState,
    isOwner,
    canViewAsVisitor,
    viewAsVisitor,
    pushBlockModal,
  }
) => {
  let items: Item[] = [];
  if (!isOwner) {
    items = [
      {
        label: giveState.canBeGivenCore
          ? t!('navigation.subnavigation.giveCore')
          : t!('navigation.subnavigation.hasCore'),
        onClick: () => window.location.assign(Url.giveCoreMembership(username)),
        disabled: !giveState.canBeGivenCore,
      },
      {
        label: t!('navigation.subnavigation.givePoints'),
        onClick: () => {
          pushPointsModal(username, t!('navigation.subnavigation.givePoints'));
        },
      },
      {
        label: giveState.canBeGivenLlama
          ? t!('navigation.subnavigation.giveLlamaBadge')
          : t!('navigation.subnavigation.hasGotLlamaBadge'),
        onClick: () => {
          pushBadgeModal(username, onLlamaBadgeSent);
        },
        disabled: !giveState.canBeGivenLlama,
      },
      {
        label: giveState.canBeGivenCake
          ? t!('navigation.subnavigation.giveCakeBadge')
          : t!('navigation.subnavigation.hasGotCakeBadge'),
        onClick: () => {
          window.location.assign(
            `${Url.checkoutLink(CHECKOUT_IDS.CAKE)}&foruserid=${userId}`
          );
        },
        disabled: !giveState.canBeGivenCake,
      },
    ];
  }
  if (canViewAsVisitor && isOwner) {
    items.push({
      label: t('navigation.subnavigation.viewAsVisitor'),
      onClick: viewAsVisitor,
      biData: { evid: BiEventType.VIEW_AS_VISITOR },
    });
  }

  if (!isOwner) {
    items.push({
      label: t('navigation.subnavigation.blockUser'),
      onClick: () => pushBlockModal(profileOwnerUser),
    });
  }

  return items;
};
